<div class="modal fade modal--alert" id="resume-policy-alert-modal" tabindex="-1" role="dialog"
  aria-labelledby="resume-modal"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img [src]="'assets/' + policy?.category_id + '/avatar/happy.png'" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" (click)="closeResumePolicyAlertModal()">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>When would you like to resume cover on {{entity == entities.Policy ? policy?.product_name : item?.description_2}}?</h4>
          </div>

          <div class="form-group mt-30 mb-0">
            <label class="custom-input custom-input--radio custom-input--pill">
              <input
                type="radio"
                name="cancel-date-cover[]"
                [checked]="resumeDateSelection === resumeDateSelectionEnum.Immediately"
                [value]="resumeDateSelectionEnum.Immediately"
                [(ngModel)]="resumeDateSelection"
                (ngModelChange)="onDateSelectionChange()">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Immediately</span>
              </label>
              <label class="custom-input custom-input--radio custom-input--pill">
                <input
                  type="radio"
                  name="cancel-date-cover[]"
                  [checked]="resumeDateSelection === resumeDateSelectionEnum.EndOfMonth"
                  [value]="resumeDateSelectionEnum.EndOfMonth"
                  [(ngModel)]="resumeDateSelection"
                  (ngModelChange)="onDateSelectionChange()">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">End of this month</span>
                </label>
                <label class="custom-input custom-input--radio custom-input--pill">
                  <input
                    type="radio"
                    name="cancel-date-cover[]"
                    [checked]="resumeDateSelection === resumeDateSelectionEnum.SpecifiedDate"
                    [value]="resumeDateSelectionEnum.SpecifiedDate"
                    [(ngModel)]="resumeDateSelection">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Choose a specific date</span>
                  </label>

                  <div class="mt-15">
                    @if (resumeDateSelection === resumeDateSelectionEnum.SpecifiedDate) {
                      <app-question-date-picker
                        [dateFormat]="'yyyy-MM-dd'"
                        [numberMonths]="1"
                        [category]="policy?.category_id"
                        (questionAnswer)="onDatePickerChange($event)">
                      </app-question-date-picker>
                    }
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-alert__button">
              <div class="container">
                <a href="javascript:void(0)" class="button button--lg button--secondary" data-dismiss="modal">Keep Paused</a>
                <a href="javascript:void(0)"
                  (click)="populateProperties()"
                  [attr.disabled]="!resumeSelectionDateModalButtonEnabled ? true : null"
                  class="button button--lg button--primary">
                  Next
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade modal--alert" id="resume-summary-page-one-modal" tabindex="-1" role="dialog"
        aria-labelledby="resume-summary" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content modal-alert modal-alert--alt">
            <div class="modal-alert__heading">
              <div class="container">
                <div class="modal-alert__avatar">
                  <img [src]="'assets/' + policy?.category_id + '/avatar/happy.png'" class="img-fluid" alt="">
                </div>
                <button class="modal-alert__close" (click)="closeResumeSummaryPageOneModal()">
                  <svg class="icon">
                    <use xlink:href="#close-medium"></use>
                  </svg>
                </button>
              </div>
            </div>

            <div class="modal-alert__content">
              <div class="container">
                <div class="rte">
                  <h4>Resume your cover</h4>
                  <p>Your paused period exceeded the [time period/anniversary] and your premium was recalculated. Please
                  review and confirm the details below before you continue. </p>
                </div>
                <div class="custom-slider-group">
                  <div class="custom-slider-group__policy">
                    <div class="custom-slider-group__policy-title">
                      <h6>{{policy?.insurer}}</h6>
                      <h5>{{policy?.product_name}}</h5>
                    </div>
                    <div class="custom-slider-group__policy-company">
                      <div class="custom-slider-group__policy-thumb">
                        <img src="{{policy?.underwriter_logo}}" class="img-fluid">
                      </div>
                      <div class="custom-slider-group__policy-rating">
                        <div class="stars stars--sm">
                          <div class="stars__star">
                            <svg class="icon">
                              <use xlink:href="#star-inactive"></use>
                            </svg>
                            <div class="stars__percent stars__percent--100">
                              <svg class="icon">
                                <use xlink:href="#star-active"></use>
                              </svg>
                            </div>
                          </div>
                          <div class="stars__star">
                            <svg class="icon">
                              <use xlink:href="#star-inactive"></use>
                            </svg>
                            <div class="stars__percent stars__percent--100">
                              <svg class="icon">
                                <use xlink:href="#star-active"></use>
                              </svg>
                            </div>
                          </div>
                          <div class="stars__star">
                            <svg class="icon">
                              <use xlink:href="#star-inactive"></use>
                            </svg>
                            <div class="stars__percent stars__percent--100">
                              <svg class="icon">
                                <use xlink:href="#star-active"></use>
                              </svg>
                            </div>
                          </div>
                          <div class="stars__star">
                            <svg class="icon">
                              <use xlink:href="#star-inactive"></use>
                            </svg>
                            <div class="stars__percent stars__percent--50">
                              <svg class="icon">
                                <use xlink:href="#star-active"></use>
                              </svg>
                            </div>
                          </div>
                          <div class="stars__star">
                            <svg class="icon">
                              <use xlink:href="#star-inactive"></use>
                            </svg>
                            <div class="stars__percent">
                              <svg class="icon">
                                <use xlink:href="#star-active"></use>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="custom-slider-group__tray">
                    <div class="custom-slider-group__actions">
                      <!-- launches edit modal as seen on /more-discounts.html -->
                      <a href="javascript:void(0)" class="text-link">Edit</a>
                    </div>
                    <div class="custom-slider-group__cost">
                      <p>
                        <strong>
                          <em>{{accounting?.formatMoney(refund?.new_prem_value)}}</em>
                        </strong> /{{policy?.frequency_short}}
                      </p>
                      @if (entity === entities.Item) {
                        <p class="is-inactive">
                          <strong>
                            <em>{{accounting?.formatMoney(refund?.curr_prem_value)}}</em>
                          </strong> /{{policy?.frequency_short}}
                        </p>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-alert__button">
              <div class="container">
                <a href="javascript:void(0)" class="button button--lg button--secondary" data-dismiss="modal">Keep Paused</a>
                <a href="#resume-summary-page-two-modal" id="resume-item-next" class="button button--lg button--primary"
                data-toggle="modal" data-dismiss="modal">Next</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div  class="modal fade modal--alert" id="resume-summary-page-two-modal" tabindex="-1" role="dialog"
        aria-labelledby="resume-summary" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content modal-alert modal-alert--alt">
            <div class="modal-alert__heading">
              <div class="container">
                <div class="modal-alert__avatar">
                  <img [src]="'assets/' + policy?.category_id + '/avatar/happy.png'" class="img-fluid" alt="">
                </div>
                <button class="modal-alert__close" (click)="closeResumeSummaryPageTwoModal()">
                  <svg class="icon">
                    <use xlink:href="#close-medium"></use>
                  </svg>
                </button>
              </div>
            </div>
            <div class="modal-alert__content">
              <div class="container">
                <div class="rte">
                  <h4>Ready to resume your cover?</h4>
                </div>
                <ul class="pause-summary mb-30">
                  <li class="pause-summary__item">
                    <div class="pause-summary__label">
                      <p>Your cover will resume on:</p>
                    </div>
                    <div class="pause-summary__value">
                      <strong>{{resumeDateValue | date:'d MMM yyyy'}}</strong>
                    </div>
                  </li>
                  <li class="pause-summary__item pause-summary__item--total">
                    <div class="pause-summary__label">
                      @if (refund) {
                        <p>
                          {{refund?.description?.length ? refund?.description[0]?.bill_descr : ''}}
                          <!--<small>({{refund?.description?.length ? refund?.description[0]?.bill_dates : ''}})</small>-->
                        </p>
                      }
                    </div>
                    <div class="pause-summary__value">
                      @if (refund) {
                        <strong>{{accounting?.formatMoney(refund?.description?.length ? refund?.description[0]?.bill_val : 0)}}</strong>
                      }
                    </div>
                  </li>
                </ul>
                <hr class="hr--bdr hr--sm"/>
                <div class="note note--naked">
                  <div class="note__content">
                    <h6>Important to know</h6>
                    <ul>
                      <li>You are not covered for the period that you paused your cover.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-alert__button">
              <div class="container">
                <a href="javascript:void(0)" (click)="removeAction(3)" id="pause-summary-no" class="button button--lg button--secondary" data-dismiss="modal">
                  No, Keep Paused
                </a>
                <a href="javascript:void(0)"
                  id="pause-summary-yes"
                  class="button button--lg button--primary"
                  (click)="changeToActive()">
                  Yes, Resume Cover
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
